import { Brand } from "../types";
import { colors } from "@storeblocks/global-styles";
export const sharedColors = {
    black: "#191919",
    white: "#fff",
};
const akaColors = {
    lightPeach: "#feeedf",
    primary: "#222274",
};
const coopColors = {
    lightBlue: "#dcf0fa",
    primary: "#003366",
};
const huseierneColors = {
    mediumGreen: "#007d68",
    primary: "#033f33",
};
const stbColors = {
    selectionMain: "#5b462b",
    surfaceBorder: "#f5e4c7",
};
export const allThemes = {
    aka: {
        circle: {
            backgroundColor: akaColors.lightPeach,
            backgroundColorActive: akaColors.primary,
            textColor: sharedColors.black,
            textColorActive: sharedColors.white,
        },
        horizontalLineBackground: akaColors.primary,
        verticalLineBackground: akaColors.primary,
    },
    coop: {
        circle: {
            backgroundColor: coopColors.lightBlue,
            backgroundColorActive: coopColors.primary,
            textColor: sharedColors.black,
            textColorActive: sharedColors.white,
        },
        horizontalLineBackground: coopColors.primary,
        iconColor: coopColors.primary,
        verticalLineBackground: coopColors.primary,
    },
    default: {
        circle: {
            backgroundColor: sharedColors.white,
            backgroundColorActive: colors.aqua.aqua70,
            textColor: sharedColors.black,
            textColorActive: sharedColors.white,
        },
        horizontalLineBackground: colors.aqua.aqua70,
        verticalLineBackground: colors.aqua.aqua70,
    },
    huseierne: {
        circle: {
            backgroundColor: huseierneColors.mediumGreen,
            backgroundColorActive: huseierneColors.primary,
            textColor: sharedColors.white,
            textColorActive: sharedColors.white,
        },
        horizontalLineBackground: huseierneColors.primary,
        verticalLineBackground: huseierneColors.primary,
    },
    stb: {
        circle: {
            backgroundColor: stbColors.surfaceBorder,
            backgroundColorActive: stbColors.selectionMain,
            textColor: sharedColors.black,
            textColorActive: sharedColors.white,
        },
        horizontalLineBackground: stbColors.selectionMain,
        verticalLineBackground: stbColors.selectionMain,
    },
};
export const getBranding = (branding) => {
    switch (branding) {
        case Brand.AKA:
            return allThemes.aka;
        case Brand.COOP:
            return allThemes.coop;
        case Brand.HUSEIERNE:
            return allThemes.huseierne;
        case Brand.STB:
            return allThemes.stb;
        case Brand.DEFAULT:
        default:
            return allThemes.default;
    }
};
//# sourceMappingURL=allThemes.js.map